module.exports = __webpack_public_path__ + "img/04—04—01—All Calls.340d6d61.jpg";